<template>
  <header>
    <div class="main-content">
      <router-link to="/" class="logo">
        <img alt="logo" src="@/assets/images/logo.png">
      </router-link>
      <div class="login-box" @click="logout" v-if="showLogout">
        <span> {{$t('Hello')}} , {{userName}}</span><span class="logoutIcon"></span>
      </div>

      <router-link to="/reset" class="reset-p" v-if="showLogout">
        {{$t('Reset Password')}}
      </router-link>

      <div class="switch-lang">
        <el-dropdown trigger="click" @command="switchLang">
          <span class="el-dropdown-link">
            {{$t(langs[currentLang])}}<i class="el-icon-caret-bottom el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(v,k) of langs"
              :command="k"
              :key="k"
              :class="{active:currentLang===k}"
              :disabled="currentLang===k">
              {{v}}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
  import util from '@/util';

  export default {
    name: 'JunketHeader',
    data() {
      return {
        langs: {
          en: 'English',
          cn: '简体中文',
          tc: '繁體中文',
          // jap: '日本語',
          // ko: '한국어'
        },
      }
    },
    methods: {
      logout: function () {

        this.axios.post('/api/junket/logout', {}).then(function (res) {
          if (res.code === 200) {
            util.removeCookie('Authorization', {path: '/'})
            util.removeCookie('userInfo', {path: '/'})
            window.location.href = "/"
          }
        })
      },

      switchLang(lang) {
        if (lang === this.currentLang) {
          return
        }
        this.$i18n.locale = lang;
        localStorage.setItem("lang", lang);
        window.location.href = '/'
      },


    },
    created() {
      if (this.showLogout && (!util.getCookie('userInfo') || !util.getCookie('Authorization'))) {
        this.$router.push({path: '/'})
      }
    },
    computed: {
      currentLang() {
        return this.$i18n.locale
      },
      showLogout() {
        return this.$route.path !== '/' && this.$route.path !== '/404' && this.userName
      },
      userName() {
        return this.$store.state?.userInfo?.name
      }
    }
  }

</script>
